import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import { useEffect, useState } from 'react';
import { pledgeInfo } from '../../api/pledge';
import { getLabel, PledgeListStatus } from '../../utils/dict';
import { AcendexLayout } from '@/components/acendex/components/layout/AcendexLayout';

// 定义字段类型接口
interface FieldType {
    orderNo?: string;
    code?: string;
    invite?: string;
    num?: number | string;
    createTime?: string;
    status?: number;
    [key: string]: any;
}

export default function repaymentList() {

    const navigate = useNavigate();
    const { t: translate } = useTranslation();
    const params = useParams();
    const [field, setField] = useState<FieldType>({});

    const getField = () => {
        pledgeInfo({
            orderNo: params.id
        }).then(res => {
            setField(res.data)
        })
    }

    useEffect(() => {
        getField()
    }, [])

    return (
        <div className='w-full min-h-dvh bg-neutral-900'>
            <AcendexLayout
                theme="light"
                mobileTopBarTitle={translate(getText("借幣明細"))}
                pcTopBarTitle={translate(getText("借幣明細"))}
            >
                <div className='container mx-auto px-4 md:px-6 py-4 max-w-4xl'>
                    <div className='bg-neutral-800 rounded-xl shadow-card overflow-hidden'>
                        <div className='divide-y divide-neutral-700'>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('訂單編號'))}</div>
                                <div className='text-neutral-100 font-medium'>{field?.orderNo}</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('貨幣'))}</div>
                                <div className='text-neutral-100 font-medium'>USDT</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('邀請碼'))}</div>
                                <div className='text-neutral-100 font-medium'>{field?.code}</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('邀請人驗證碼'))}</div>
                                <div className='text-neutral-100 font-medium'>{field?.invite}</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('借幣數量'))}</div>
                                <div className='text-neutral-100 font-medium'>{field?.num}</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'>{translate(getText('時間'))}</div>
                                <div className='text-neutral-100 font-medium'>{field?.createTime}</div>
                            </div>
                            <div className='flex justify-between items-center p-4 text-sm'>
                                <div className='text-neutral-400'></div>
                                <div className='text-primary font-medium'>{translate(getText(getLabel(PledgeListStatus, field?.status || 0)))}</div>
                            </div>
                        </div>
                    </div>
                    
                    {/* {field.status == 3 && (
                        <div className='mt-6'>
                            <button 
                                onClick={() => navigate(`/repayment/${field.orderNo}/${field.num}`)} 
                                className='w-full bg-gradient-primary text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity'
                            >
                                {translate(getText('還幣'))}
                            </button>
                        </div>
                    )} */}
                </div>
            </AcendexLayout>
        </div>
    )
}